var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAaneelPoweredby(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145 26.7228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 60.304,
    cy: 53.6573,
    fx: 60.304,
    fy: 53.6573,
    r: 22.4252,
    gradientTransform: "translate(-16.4652 -35.3334) rotate(2.9062)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#faaf40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#f05a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#dc5124"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4854,
    stopColor: "#c0441e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#b6401c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5964,
    stopColor: "#ac3b19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6757,
    stopColor: "#932e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7758,
    stopColor: "#6a190a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#3e0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#280000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.3297,
    cy: 18.8705,
    fx: 0.3297,
    fy: 18.8705,
    r: 29.3348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e94d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2921,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3064,
    stopColor: "#1970b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4193,
    stopColor: "#0b4c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5033,
    stopColor: "#033658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5484,
    stopColor: "#002e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6556,
    stopColor: "#00203a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8738,
    stopColor: "#00081e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000014"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 10.6664,
    cy: 21.5019,
    fx: 10.6664,
    fy: 21.5019,
    r: 16.4778,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 31.4157,
    cy: 6.7782,
    fx: 31.4157,
    fy: 6.7782,
    r: 21.6352,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 19.334,
    cy: 6.7782,
    fx: 19.334,
    fy: 6.7782,
    r: 21.6609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#40b5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1365,
    stopColor: "#2e94d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3351,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4268,
    stopColor: "#14629d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5859,
    stopColor: "#09456f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7088,
    stopColor: "#023353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#002d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9677,
    stopColor: "#001934"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 69.204,
    y1: 14.8952,
    x2: 71.948,
    y2: 18.207,
    gradientTransform: "translate(-42.1922 -5.6703) rotate(-2.3728)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 58.4121,
    y1: 13.1087,
    x2: 59.2219,
    y2: 14.086,
    gradientTransform: "translate(-42.1922 -5.6702) rotate(-2.3728)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 97.1788,
    cy: -15.8361,
    fx: 97.1788,
    fy: -15.8361,
    r: 3.5292,
    gradientTransform: "translate(71.4593 99.0421) rotate(-89.851)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0108,
    stopColor: "#ade1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1956,
    stopColor: "#00a6e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3943,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4444,
    stopColor: "#1a6aad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5372,
    stopColor: "#194f8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5645,
    stopColor: "#194680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0d2657"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7338,
    stopColor: "#030a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7796,
    stopColor: "#000025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8206,
    stopColor: "#000228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8564,
    stopColor: "#020b33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8904,
    stopColor: "#051945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9231,
    stopColor: "#0a2c5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#10467e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9859,
    stopColor: "#1764a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.0792,21.479s.4634,2.8673,3.0466,3.9393c.1826,.0773-.0355-.2683,.1658-.2122l.9384-.4945L57.214,5.5852s-1.3594,1.3776-3.7045,.4258c-1.0902-.4449-1.8417-1.5499-1.8417-1.5499l-10.5886,17.018Z",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3721,17.9455L14.2963,6.9459s4.6286-5.6653,9.3407,1.1189c0,0-3.3306-1.3418-7.1446,5.2106l-6.7558,10.9936s-3.141,5.0642-9.7366,.5313c0,0,2.6986-.4955,4.1074-1.9883,.6074-.6424,2.7531-4.0073,3.2647-4.8665Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4437,17.973l6.9269-10.9993s4.6286-5.6656,9.3412,1.1187c0,0-3.3317-1.3415-7.1428,5.2077l-6.7231,10.969s-3.1441,5.0611-9.7385,.5313c0,0,2.6995-.4955,4.1108-1.9883,.6056-.6424,2.7179-3.9767,3.2254-4.839Z",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3772,6.9765s2.5891-.6364,4.3095,3.499l5.7629,13.0421s1.0266,3.2077,4.2306,3.2051c1.8677,0,2.7524-.3871,4.5751-2.0433,0,0-2.2148-.8183-3.0465-2.418-.3285-.6341-.9174-1.9613-.9174-1.9613,0,0-2.22-4.8572-2.907-6.3744-.6253-1.3771-1.7128-4.3103-2.4488-5.6604-.8484-1.5613-3.3117-4.8644-6.9876-3.3672-1.0357,.4174-1.7831,.9934-2.5708,2.0783Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.277,6.9765s2.5913-.6364,4.3121,3.499l5.7633,13.0421s1.0248,3.2077,4.227,3.2051c1.8697,0,2.8198-.4338,4.6444-2.0869,0,0-2.1274-.5401-2.9596-2.1409-.3295-.6361-1.0712-2.1948-1.0712-2.1948,0,0-2.2174-4.8572-2.9052-6.3744-.6234-1.3771-1.7128-4.3103-2.4491-5.6604-.8478-1.5613-3.3132-4.8644-6.9869-3.3672-1.0351,.4174-1.7826,.9934-2.5749,2.0783Z",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9518,6.6657s4.2322-5.1041,8.6805,1.2658l5.5885,12.4371s-2.2353,4.1214,.1357,6.0397c0,0-3.018,.4265-4.0638-2.0231,0,0-4.2771-9.4684-7.1-15.3654-1.0668-2.2293-2.5858-2.2216-3.2409-2.3541Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7941,6.6932s4.0407-5.1708,8.5726,1.3159l.2664,.5619s-1.3236,9.4876-3.9906,3.7908c-.5389-1.1519-1.0634-2.2623-1.5489-3.2694-1.0878-2.2714-2.6317-2.2659-3.2995-2.3993Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.1837,0c1.5553,.0023,2.8125,1.2689,2.8076,2.8281-.0037,1.5546-1.2684,2.8128-2.8255,2.8068-1.5553-.0031-2.8149-1.266-2.81-2.8245C52.3613,1.2544,53.6242-.0057,55.1837,0Z",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3597,1.7637c0,.1738-.1972,.3072-.4418,.3072-.2441-.0031-.4413-.1417-.4392-.3072,0-.1692,.1964-.308,.4392-.3056,.2447,.0023,.4418,.1396,.4418,.3056Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6984,2.1235c0,.0561-.0656,.0965-.1463,.0965-.0794,0-.1437-.0405-.1414-.0965,0-.0558,.062-.1002,.1437-.1002,.0784,0,.144,.0444,.144,.1002Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.4379,9.6386c2.1756,0,4.029,.6179,5.56,1.8534,1.5299,1.236,2.2952,2.7238,2.2952,4.4647v6.6976c0,.2527-.1333,.4665-.4006,.6418-.2667,.1754-.5899,.2636-.9682,.2636-.3798,0-.7062-.0882-.9794-.2636-.2742-.1753-.4112-.3891-.4112-.6418v-3.3908h-7.4759c-.379,0-.7054-.0913-.9797-.274-.2732-.1827-.4104-.4001-.4104-.6527s.1372-.4701,.4104-.6523c.2742-.1831,.6006-.2745,.9797-.2745h7.4759v-1.4533c0-1.2354-.4979-2.2883-1.4949-3.1584-.997-.8706-2.1972-1.3063-3.601-1.3063s-2.6045,.4356-3.6015,1.3063c-.9967,.8702-1.4954,1.923-1.4954,3.1584v6.7183c0,.2527-.1331,.4701-.4,.6533-.267,.1821-.5897,.2734-.9688,.2734-.3933,0-.723-.0913-.99-.2734-.2667-.1831-.4-.4006-.4-.6533v-6.7183c0-1.7408,.769-3.2287,2.3058-4.4647,1.5377-1.2354,3.3872-1.8534,5.5499-1.8534Z",
    fill: "#1b75bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8669,18.2107c0-1.5302,.6776-2.8362,2.0324-3.9175,1.3548-1.0813,2.9872-1.622,4.8966-1.622s3.5418,.5407,4.8966,1.622c1.3548,1.0814,2.0324,2.3874,2.0324,3.9175v4.4436c0,.2527-.137,.4665-.411,.6418-.2734,.1754-.5998,.2636-.9796,.2636-.3783,0-.7015-.0882-.9682-.2636-.2672-.1753-.4006-.3891-.4006-.6418v-4.4436c0-1.0248-.4073-1.8996-1.2214-2.6224-.8141-.7228-1.7974-1.0844-2.9482-1.0844s-2.1347,.3617-2.9483,1.0844c-.8141,.7228-1.2219,1.5976-1.2219,2.6224,0,1.0107,.4078,1.8778,1.2219,2.6006,.8136,.7228,1.7974,1.085,2.9483,1.085,.4768,0,.9479-.0706,1.4108-.2112,.1967-.0695,.4001-.1048,.6108-.1048,.3087,0,.6143,.0804,.9163,.2418,.3014,.1614,.453,.3897,.453,.6849,0,.3788-.2527,.6527-.7581,.8214-.8421,.2802-1.7201,.4213-2.6327,.4213-1.9095,0-3.5418-.5443-4.8966-1.6329-1.3548-1.088-2.0324-2.3899-2.0324-3.906Z",
    fill: "#1b75bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5108,15.9151c0-4.0433,1.5161-6.0651,4.5489-6.0651,1.5302,0,2.8782,.8836,4.0436,2.6527,.758,1.1656,1.3615,2.5557,1.8109,4.1704,.3507,1.2775,.8317,2.4568,1.443,3.5382,.6102,1.0808,1.1265,1.6635,1.5478,1.7475,.6034,0,1.0777-.3653,1.4212-1.0948,.344-.73,.5163-1.7273,.5163-2.9908v-7.1397c0-.2527,.137-.4701,.4104-.6525,.2745-.1821,.6003-.2743,.9797-.2743,.3788,0,.702,.0921,.9687,.2743,.2667,.1824,.3996,.3998,.3996,.6525v7.1397c0,3.9455-1.5649,5.9177-4.6958,5.9177-1.5302,0-2.8502-.8769-3.9595-2.6322-.702-1.0953-1.2847-2.4782-1.7475-4.1484-.3513-1.2785-.853-2.4605-1.5063-3.5488-.6522-1.0884-1.197-1.6742-1.6319-1.7585-.5474,0-.9827,.3821-1.306,1.1472-.3227,.7651-.4846,1.7867-.4846,3.0647v6.7391c0,.2527-.1334,.4665-.3995,.6418-.2667,.1754-.59,.2636-.9688,.2636-.3928,0-.7228-.0882-.9905-.2636-.2662-.1753-.3996-.3891-.3996-.6418v-6.7391Z",
    fill: "#1b75bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2809,18.2107c0-1.5302,.6771-2.8362,2.0319-3.9175,1.3548-1.0813,2.9877-1.622,4.8966-1.622,1.4607,0,2.7869,.3339,3.9803,1.0009,1.1939,.6672,2.0361,1.5411,2.5269,2.6213,.0841,.1971,.1271,.3938,.1271,.5899,0,.604-.316,.9547-.948,1.0538l-7.4132,1.2204c-.1126,.0145-.2241,.0218-.3368,.0218-.3233,0-.6185-.0706-.8847-.2107-.3373-.1826-.5054-.4213-.5054-.716,0-.4774,.3508-.7721,1.0528-.8847l5.981-.9687c-.8141-1.2635-2.008-1.8955-3.5802-1.8955-1.1509,0-2.1341,.3617-2.9482,1.0844-.8141,.7228-1.2214,1.5976-1.2214,2.6224,0,1.0107,.4073,1.8778,1.2214,2.6006,.8141,.7228,1.7974,1.085,2.9482,1.085,1.4741,0,2.6322-.5552,3.4744-1.6641,.2532-.3367,.6605-.5053,1.2225-.5053,.2246,0,.4348,.0285,.6309,.0841,.5053,.1686,.758,.4421,.758,.8219,0,.1541-.0488,.2942-.1468,.4213-.632,.8422-1.4705,1.5016-2.5166,1.9784-1.046,.4779-2.187,.7171-3.4225,.7171-1.9089,0-3.5418-.5443-4.8966-1.6329-1.3548-1.088-2.0319-2.3899-2.0319-3.906Z",
    fill: "#1b75bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.9972,18.2107c0-1.5302,.6777-2.8362,2.0324-3.9175,1.3548-1.0813,2.9876-1.622,4.8966-1.622,1.4606,0,2.7869,.3339,3.9808,1.0009,1.1929,.6672,2.0355,1.5411,2.5269,2.6213,.0846,.1971,.1261,.3938,.1261,.5899,0,.604-.316,.9547-.9475,1.0538l-7.4131,1.2204c-.1126,.0145-.2247,.0218-.3373,.0218-.3227,0-.618-.0706-.8842-.2107-.3372-.1826-.5053-.4213-.5053-.716,0-.4774,.3507-.7721,1.0528-.8847l5.9811-.9687c-.8142-1.2635-2.008-1.8955-3.5802-1.8955-1.1509,0-2.1341,.3617-2.9483,1.0844-.8141,.7228-1.2214,1.5976-1.2214,2.6224,0,1.0107,.4073,1.8778,1.2214,2.6006,.8142,.7228,1.7974,1.085,2.9483,1.085,1.4741,0,2.6328-.5552,3.4754-1.6641,.2527-.3367,.6595-.5053,1.2204-.5053,.2252,0,.4358,.0285,.633,.0841,.5053,.1686,.758,.4421,.758,.8219,0,.1541-.0498,.2942-.1479,.4213-.632,.8422-1.4705,1.5016-2.5165,1.9784-1.0461,.4779-2.187,.7171-3.4225,.7171-1.9089,0-3.5418-.5443-4.8966-1.6329-1.3548-1.088-2.0324-2.3899-2.0324-3.906Z",
    fill: "#1b75bb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2406,10.7337c0-.2527,.1334-.4701,.4006-.6525,.2667-.1821,.5967-.2743,.9895-.2743,.3793,0,.702,.0921,.9688,.2743,.2667,.1824,.4006,.3998,.4006,.6525v11.9206c0,.2527-.1339,.4665-.4006,.6418-.2667,.1754-.5895,.2636-.9688,.2636-.3928,0-.7228-.0882-.9895-.2636-.2672-.1753-.4006-.3891-.4006-.6418V10.7337Z",
    fill: "#1b75bb"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaneelPoweredby);
export default __webpack_public_path__ + "static/media/aaneel-poweredby.e33dbf1d0b3b70f5f7cc92667a9dd981.svg";
export { ForwardRef as ReactComponent };